import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";

import { nganHangApi } from "../../../api/ngan-hang/nganHangApi";
import {
  eNganHangActionIds,
  INganHangActionTypes,
} from "../../action-types/ngan-hang/INganHangActions";
import { IAccThietLapNganHang } from "../../../model/respone/category/IAccThietLapNganHang";
import { IGenQRRequest } from "../../../model/request/ngan-hang/IGenQRRequest";
import { ITraSoatQRRequest } from "../../../model/request/ngan-hang/ITraSoatQRRequest";

const mainAction = rootActions.nganHang.nganHang;

export function* nganHangSaga(): any {
  yield takeLatest(eNganHangActionIds.LOAD_START, loadWorker);
  yield takeEvery(eNganHangActionIds.SAVE_START, saveWorker);
  yield takeEvery(eNganHangActionIds.DELETE_START, deleteWorker);
  yield takeLatest(eNganHangActionIds.GENQR_START, genQRWorker);
  yield takeLatest(eNganHangActionIds.TRA_SOAT_START, traSoatWorker);
  yield takeLatest(eNganHangActionIds.LOAD_BANK_START, loadBankWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(nganHangApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: INganHangActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IAccThietLapNganHang;
  if (payload.id > 0) {
    res = yield call(nganHangApi.Update, payload);
  } else {
    res = yield call(nganHangApi.Insert, payload);
  }
  if (res)
    if (res.is_success) {
      yield put(rootActions.nganHang.nganHang.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.nganHang.nganHang.SAVE_ERROR(res.message ?? "Có lỗi")
      );
    }
}

function* deleteWorker(action: INganHangActionTypes): any {
  const res: IBaseRespone = yield call(
    nganHangApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.nganHang.nganHang.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.nganHang.nganHang.DELETE_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* genQRWorker(action: INganHangActionTypes): any {
  const request = action.payload as IGenQRRequest;
  const res: IBaseRespone = yield call(nganHangApi.GenQR, request);
  if (res.is_success) {
    yield put(rootActions.nganHang.nganHang.GENQR_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.nganHang.nganHang.GENQR_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* traSoatWorker(action: INganHangActionTypes): any {
  const request = action.payload as ITraSoatQRRequest;
  const res: IBaseRespone = yield call(nganHangApi.TraSoatQR, request);
  if (res.is_success) {
    yield put(rootActions.nganHang.nganHang.TRA_SOAT_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.nganHang.nganHang.TRA_SOAT_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* loadBankWorker(action: INganHangActionTypes): any {
  const request = action.payload as string;
  if (request) {
    const res: IBaseRespone = yield call(
      nganHangApi.SelectBank,
      action.payload as string
    );
    if (res.is_success) {
      yield put(rootActions.nganHang.nganHang.LOAD_BANK_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.nganHang.nganHang.LOAD_BANK_ERRR(res.message ?? "Có lỗi")
      );
    }
  } else {
    yield put(rootActions.nganHang.nganHang.LOAD_BANK_SUCCESS([]));
  }
}

export default nganHangSaga;
